export default "/images/979aa44177d6e0fd38a989a9b4eb2ab7.jpg";